import CustomTooltip from "shared/components/CustomTooltip";
import { IconDispatcher } from "shared/Icons";
import styled, { css } from "styled-components/macro";
import { getEmotionLevelData } from "utils/helpers";

interface SmileyStaticComponentProps {
	emotionLevel: number;
	size?: number;
	isTooltipDisabled: boolean;
}

export const SmileyStaticComponent: React.FC<SmileyStaticComponentProps> = ({ emotionLevel, size, isTooltipDisabled = false }) => {
	const { smiley, smileyColor, description } = getEmotionLevelData({ level: emotionLevel });
	return (
		<CustomTooltip text={description} placement="bottom" disabled={isTooltipDisabled}>
			<Container size={size}>
				<WhiteBackground>
					<Icon size={size} color={smileyColor}>
						{IconDispatcher(smiley)}
					</Icon>
				</WhiteBackground>
			</Container>
		</CustomTooltip>
	);
};

const Container = styled.div<{ size: number }>`
	width: ${({ size }) => size}px;
	height: ${({ size }) => size}px;
	flex-shrink: 0;
	display: flex;
	align-items: center;
	justify-content: center;
`;

const WhiteBackground = styled.div`
	width: 100%;
	height: 100%;
	border-radius: 50%;
	background: #ffffff;
	display: flex;
	align-items: center;
	justify-content: center;
`;

const Icon = styled.div<{ size: number; color: string }>`
	display: flex;
	align-items: center;
	justify-content: center;
	svg {
		width: ${({ size }) => size}px;
		height: ${({ size }) => size}px;
		color: ${({ color }) => color};
	}
`;
